import { useContext, useEffect } from 'react'

import { List } from 'antd'

import IndividualInternshipRequestCard from './IndividualInternshipRequestCard'
import InternshipRequestFilesDrawer from '../../institution/InternshipsView/InternshipsRequestsView/InternshipRequestFilesDrawer'
import InternshipRequestButton from './InternshipRequestButton'
import { getIdOrNull } from '../../../utils'
import { IndividualInternshipRequestModalContext } from '../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'
import { InternshipRequest, Origins } from '../../../utils/entities/internshipRequest'
import { RequestPortalContext } from '../../../Providers/RequestPortalProvider'

const InternshipRequestsList = ({ institution, internshipRequests, student, reload, onDelete }) => {
  const { setHandler } = useContext(IndividualInternshipRequestModalContext)
  const { setInstitution } = useContext(RequestPortalContext)

  useEffect(() => {
    if (getIdOrNull(institution) && getIdOrNull(student)) {
      setHandler(form => ({
        ...form,
        data: new InternshipRequest({ student, institution, requestOrigin: Origins.WEB_PORTAL }),
        callback: () => {
          reload()
          setInstitution(null)
        }
      }))
    }
  }, [institution, student])

  return (
    <div className='internship-requests-list h-100'>
      {internshipRequests.length > 0 && (
        <div className='overflow-y' style={{ height: 'calc(100% - 42px)' }}>
          <InternshipRequestFilesDrawer>
            <List>
              {internshipRequests.map(ir => (
                <List.Item key={ir.id}>
                  <IndividualInternshipRequestCard internshipRequest={ir} callback={reload} onDelete={onDelete} />
                </List.Item>
              ))}
            </List>
          </InternshipRequestFilesDrawer>
        </div>
      )}
      <InternshipRequestButton student={student} reload={reload} />
    </div>
  )
}

export default InternshipRequestsList
